import { render, staticRenderFns } from "./boardRejected.vue?vue&type=template&id=0ae0360d&scoped=true"
import script from "./boardRejected.vue?vue&type=script&lang=js"
export * from "./boardRejected.vue?vue&type=script&lang=js"
import style0 from "./boardRejected.vue?vue&type=style&index=0&id=0ae0360d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae0360d",
  null
  
)

export default component.exports